import { useContext, useEffect, useState } from "react";
import Select from "react-select";
import CountryCard from "../../components/country-card/country-card.component";
import SearchBox from "../../components/search-box/search-box.component";
import { CountriesContext } from "../../context/countries.context";
import { InputContext } from "../../context/input.context";
import { ModeContext } from "../../context/mode.context";
import "./home.router.scss";

const Home = () => {
  const { countries } = useContext(CountriesContext);
  const { input } = useContext(InputContext);
  const { mode } = useContext(ModeContext);
  const [selectValue, setSelectValue] = useState({
    value: "All",
    label: "All",
  });


  const [filteredCountries, setFilteredCountries] = useState([countries]);

  const options = [
    { value: "Asia", label: "Asia" },
    { value: "Africa", label: "Africa" },
    { value: "Americas", label: "Americas" },
    { value: "Europe", label: "Europe" },
    { value: "Oceania", label: "Oceania" },
    {
      value: "All",
      label: "All",
    },
  ];

  useEffect(() => {
    if (selectValue.value === "All") {
      setFilteredCountries(countries);
    }
    const newFilteredCountries = countries.filter(
      (country) =>
        country.region.toLocaleLowerCase() ===
        selectValue.value.toLocaleLowerCase()
    );
    setFilteredCountries(newFilteredCountries);
  }, [selectValue, countries]);

  useEffect(() => {
    const newFilteredCountries = countries.filter((country) =>
      country.name.toLocaleLowerCase().includes(input.toLocaleLowerCase())
    );
    setFilteredCountries(newFilteredCountries);
  }, [input, countries]);

  

  return (
    <div className={`home ${mode ? ` home-dark` : ``}`}>
      <div className={`home__input ${mode ? `home-dark__input` : ``}`}>
        <SearchBox />
        <Select
          options={options}
          defaultValue={selectValue}
          placeholder="Filter by region..."
          className="select"
          onChange={setSelectValue}
        />
      </div>
      <div className="home__country">
        {filteredCountries.map((country) => {
          return <CountryCard key={country.name} country={country} />;
        })}
      </div>
    </div>
  );
};

export default Home;
